import { ParametroEmpresaService } from './../../../../services/parametro-empresa.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MixturaService } from 'src/app/services/mixtura.service';
import { RubroService } from 'src/app/services/rubro.service';
import { SignalRMessageService } from 'src/app/services/SignalRMessage.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ENVIRONMENT_FUNCTIONS } from 'src/environments/environment';

@Component({
  selector: 'app-reporte-general',
  templateUrl: './reporte-general.component.html',
  styleUrls: ['./reporte-general.component.scss'],
  providers: [SecurityService],
})
export class ReporteGeneralComponent implements OnInit {
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;

  // Contants
  readonly RB_TIPO_VISTA_6: String = '_RB_TIPO_VISTA_6_';
  readonly RB_TIPO_VISTA_12: String = '_RB_TIPO_VISTA_12_';

  // Form
  formHeader: FormGroup;

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  private currentPayload: any = null;
  loading: boolean = false;
  listaMovimientos: Array<any> = null;
  listaMovimientosAll: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();
  totales: any = null;
  monthsFormatted: string[] = [...Array(12).keys().toString()]; //.map(p => '')
  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsMixtura: Array<any> = [];
  public permiteVerMixtura: boolean = false;
  processing: boolean = false;

  clientesSeleccionados: Array<any> = null;
  // tiposClientesSeleccionados: any = null

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private rubroService: RubroService,
    private mixturaService: MixturaService,
    private familiaService: FamiliaService,
    private clienteProveedorService: ClienteProveedorService,
    private parametroEmpresaService: ParametroEmpresaService,
    public rutService: RutService,
    private signalRMessageService: SignalRMessageService,
  ) {
    this.log = this.clog.log('REP. PRODUCTOS ANUALIZADO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.loadMonths();
    this.loadYears();
    this.loadRubros();
    this.loadMixturas();
    this.parametroMixtura();
    this.createForm();
    // LISTENER OPCION CHANGE 6 MESES Y 12 MESES
    // this.formChangesSubscriptions();
    this.setDefaults();

    this.optionsMixtura = [
      { value: '1', label: 'Mixtura 1' },
      { value: '2', label: 'Mixtura 2' },
      { value: '3', label: 'Mixtura 3' },
    ];
  }

  parametroMixtura() {
    this.parametroEmpresaService.permiteVisualizarMixtura(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteVerMixtura = respuesta.valor_bool;
    });
  }

  loadMonths() {
    this.optionsMonth = this.datesService.GetMonths();
  }

  loadYears() {
    this.optionsYear = this.datesService.GetLastYears(10);
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((rubro) => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }));
    });
  }

  private loadMixturas() {
    this.mixturaService.obtenerTodos(({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsMixtura = registros.map((mix) => ({ value: mix.codigo, label: mix.nombre.toUpperCase(), ...mix }));
    });
  }

  private createForm() {
    this.formHeader = this.fb.group({
      mes: [null, [Validators.required]],
      anho: [null, [Validators.required]],
      listaRubro: [[]],
      listaMixtura: [[]],
      incl_cliente_inactivos: [false],
      tipoVista: [this.RB_TIPO_VISTA_6],
      cliente_sin_venta: false,
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get('tipoVista').valueChanges.subscribe((rubro: string) => {
      this.buscar(1);
    });
  }

  setDefaults() {
    if (this.optionsMonth.length > 0) this.formHeader.get('mes').setValue(new Date().getMonth() + 1);
    if (this.optionsYear.length > 0) this.formHeader.get('anho').setValue(this.optionsYear[0].value);
  }

  abrirModalSeleccion() {
    // if (this.formHeader.get('buscarPor').value === this.TIPO_CLIENTE)
    //   this.abrirModalSeleccionarCliente()
    // else if (this.formHeader.get('buscarPor').value === this.TIPO_TIPO_CLIENTE)
    //   this.abrirModalSeleccionarClientesTipos()
    this.abrirModalSeleccionarCliente();
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected();
  }

  onClienteSeleccionadoMultiple({ data, origen }) {
    this.log(origen, data);
    this.limpiarDataSeleccionada();
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data;
  }

  onClienteSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada();
    // this.formHeader.get('rutCliente').setValue('')
    this.clientesSeleccionados = [data];
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null;
    // this.tiposClientesSeleccionados = null
  }

  // abrirModalSeleccionarClientesTipos() {
  //   this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados)
  // }

  // onRubroSelect(ev) {
  //   this.optionsFamilia = []

  //   const listaRubros = this.formHeader.get('listaRubro').value
  //   if (!listaRubros) return

  //   for (let i = 0; i < listaRubros.length; i++) {
  //     this.loadFamilias(listaRubros[i])
  //   }
  // }

  // private loadFamilias(codigoRubro: Number) {
  //   this.familiaService.obtenerFamiliaxRubro(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
  //     const { registros } = respuesta; //.registros.filter(p => p.estado);
  //     let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
  //     this.optionsFamilia = this.optionsFamilia.concat(options)
  //   })
  // }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.paginationContext.CurrentPage = pageNumber;

    this.listaMovimientos = [];
    this.listaMovimientosAll = [];

    const { mes, anho, listaRubro, listaMixtura, incl_cliente_inactivos, cliente_sin_venta } = this.formHeader.value;
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        mes,
        anno: anho,
        listaRubro,
        listaMixtura,
        listaCliente: this.clientesSeleccionados ? this.clientesSeleccionados.map((cliente) => cliente.rut) : [],
        incl_cliente_inactivos,
        tiene_venta: cliente_sin_venta,
        tipoVista: this.formHeader.get('tipoVista').value,
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.currentPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.clienteProveedorService.obtenerReporteVentaGeneral(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.generateMonthsArray();

      const { registros } = respuesta;

      this.listaMovimientosAll = registros;

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      // this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach((mov) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.rut);
      });

      this.showPage(this.paginationContext.CurrentPage);
      this.calculateTotales();
      this.loading = false;
    });
  }


  reporteGeneralBuscarNotificacion() {

    this.listaMovimientos = [];
    this.listaMovimientosAll = [];

    const { mes, anho, listaMixtura, listaRubro, cliente_sin_venta, incl_cliente_inactivos } = this.formHeader.value;
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 8,
        categoria_modulo_codigo: 4,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        mes: mes,
        anno: anho,
        listaCliente: this.clientesSeleccionados ? this.clientesSeleccionados.map((cliente) => cliente.rut) : [],
        listaMixtura,
        listaRubro,
        tiene_venta: cliente_sin_venta,
        tipoVista: this.formHeader.get('tipoVista').value,
        incl_cliente_inactivos,
        environment_functions: ENVIRONMENT_FUNCTIONS
      },
      paginaActual: 1, //this.cliente_producto_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.currentPayload = inputParams;
    this.sendMessage(inputParams);
  }

  sendMessage(inputParams: any) {
    this.signalRMessageService.send(inputParams).subscribe(
      () => {
        //console.log('Mensaje enviado con éxito');
      },
      (error) => {
        console.error('Error al enviar el mensaje:', error);
      }
    );
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  calculateTotales() {
    this.totales = {
      cantidad: _.sumBy(this.listaMovimientosAll, 'cantidad'),
      maquinas: _.sumBy(this.listaMovimientosAll, 'total_maquina'),
      mes1: _.sumBy(this.listaMovimientosAll, 'mes12'),
      mes2: _.sumBy(this.listaMovimientosAll, 'mes11'),
      mes3: _.sumBy(this.listaMovimientosAll, 'mes10'),
      mes4: _.sumBy(this.listaMovimientosAll, 'mes9'),
      mes5: _.sumBy(this.listaMovimientosAll, 'mes8'),
      mes6: _.sumBy(this.listaMovimientosAll, 'mes7'),
      mes7: _.sumBy(this.listaMovimientosAll, 'mes6'),
      mes8: _.sumBy(this.listaMovimientosAll, 'mes5'),
      mes9: _.sumBy(this.listaMovimientosAll, 'mes4'),
      mes10: _.sumBy(this.listaMovimientosAll, 'mes3'),
      mes11: _.sumBy(this.listaMovimientosAll, 'mes2'),
      mes12: _.sumBy(this.listaMovimientosAll, 'mes1'),
      total6meses: _.sumBy(this.listaMovimientosAll, 'total_6meses'),
      total12meses: _.sumBy(this.listaMovimientosAll, 'total_12meses'),
    };
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.processing = true;
    this.clienteProveedorService.obtenerReporteVentaGeneralExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
      try {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
      } catch (error) {
        this.messageRendererService.showErrors(['Error al descargar el archivo.', error && error.message ? error.message : error]);
      } finally {
        this.processing = false;
      }
    });
  }

  generateMonthsArray() {
    const { mes, anho } = this.formHeader.value;
    const months = this.datesService.GetMonthsRange(Number(mes) + 1, Number(anho) - 1).reverse();
    this.monthsFormatted = months.map((month) => this.datesService.formatShortMonthYear(month));
  }

  LimpiarData() {
    this.formHeader.reset();
    this.setDefaults();
    this.clientesSeleccionados = null;
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_6);
    this.formHeader.get('listaRubro').setValue([]);
    this.formHeader.get('incl_cliente_inactivos').setValue(false);
    this.formHeader.get('cliente_sin_venta').setValue(false);
    this.listaMovimientos = null;
    this.listaMovimientosAll = null;
  }

  closeAlert() {
    this.listaMovimientos = null;
    this.listaMovimientosAll = null;
  }
}
